import { Skeleton, Typography } from "@mui/material"
import { groupBy } from "@shared/lib/utils";
import MuiInput from "@shared/ui/mui-input/MuiInput";
import { UseFormReturn } from "react-hook-form";
import { StyledAddBank } from "./AddBank.styled";
import { AccountAdd } from "../../../../../models/account";
import { useGetAccountStructureQuery } from "@features/structures/api/accountsStructure.api";
import { useTheme } from "@emotion/react";


interface AddBankProps {
  useForm: UseFormReturn<AccountAdd>
}

function AddBank({ useForm }: AddBankProps) {
  const theme = useTheme();

  const { 
    data: bankStructure,
    isFetching,
  } = useGetAccountStructureQuery("בנק");

  const structureSortedByTitle = groupBy(bankStructure, "account_title")
  const customFieldsExist = structureSortedByTitle?.["מותאם אישית"]?.find(structure=> !!structure.show_form === true);

  return (
    <StyledAddBank>
      {isFetching && (<Skeleton variant="rectangular" height={500} animation="wave" sx={{ bgcolor: theme.colors.section_color }} />)}
      {!isFetching && bankStructure &&
        <>
          <div>
            <Typography variant="body1">פרטי עבודה</Typography>
            <div className="fields">
              {structureSortedByTitle?.["פרטים"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

          <div>
            {customFieldsExist && (<Typography variant="body1">שדות מותאמים אישית:</Typography>)}
            <div className="fields">
              { structureSortedByTitle?.["מותאם אישית"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

        </>}

    </StyledAddBank>
  )
}

export default AddBank